// Product analytics for the overlay line-style editor.
//
// Split out from the Vue component so the event name and property shape are
// one testable pure boundary shared with iOS/Android (which emit the same
// event name and `overlay` values through their own SDKs).

import type { OverlayLineType } from './overlayLineStyles';
import { cloudTypeForOverlayType } from './routeStyleSettingsCloudMapping';

export const OVERLAY_LINE_STYLE_EVENT = 'Overlay Line Style Changed';

export interface OverlayLineStyleEventProps {
  overlay: string;
  property: string;
  value: string | number | null;
}

/**
 * Builds the analytics payload. `overlay` reuses the cloud `route_type` key
 * (minus the `overlay_` prefix) so the same value identifies an overlay in
 * analytics, in the API, and in the mobile clients.
 */
export function overlayLineStyleEventProps(
  overlayType: OverlayLineType,
  property: string,
  value: string | number | null,
): OverlayLineStyleEventProps {
  return {
    overlay: cloudTypeForOverlayType(overlayType).replace(/^overlay_/, ''),
    property,
    value,
  };
}

/** Fire-and-forget; never let a missing analytics shim break a style edit. */
export function trackOverlayLineStyleChanged(
  overlayType: OverlayLineType,
  property: string,
  value: string | number | null,
): void {
  try {
    window.mixpanel?.track(
      OVERLAY_LINE_STYLE_EVENT,
      overlayLineStyleEventProps(overlayType, property, value),
    );
  } catch {}
}
